module.exports = __webpack_public_path__ + "img/strategic.0f7b89e1.svg";